import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getLocationTimezone, extractLocation } from 'helpers/locations';
import { withTranslation } from 'react-i18next';
import { withLocaleContext } from 'providers/locale-settings-context';
import AppointmentConfirmationBadge from './AppointmentConfirmationBadge';
import IconTextDisplay from '../../../v2/IconTextDisplay';
import { CalendarIcon } from 'lucide-react';
class StopAppointmentWindow extends Component {
    constructor() {
        super(...arguments);
        this.handleEditAppointmentWindow = () => this.props.onEditAppointmentWindow(this.props.stop);
    }
    render() {
        const { stop, shipment_type, editable } = this.props;
        const { appointment_unconfirmed, window_end, window_start, empty } = stop;
        const location = extractLocation(stop.location);
        const timezone = getLocationTimezone(location);
        const isDrayage = shipment_type === 'drayage';
        const dateNotSetForNonDrayage = !isDrayage && !window_start && !window_end;
        const appointmentStatusVisible = isDrayage && !empty;
        const { t, formatDateTime } = this.props;
        return (React.createElement("div", { className: "relative flex items-center mb-2" },
            React.createElement("div", null,
                React.createElement("button", { disabled: !editable, className: "block", onClick: this.handleEditAppointmentWindow, title: t('CLICK_APPOINTMENT_WINDOW') },
                    !stop.window_start && !stop.window_end && (React.createElement(IconTextDisplay, { className: "items-center", icon: React.createElement(CalendarIcon, { className: "w-4 h-4 text-gray-700" }) }, !stop.empty && (React.createElement("div", { className: "text-sm text-red-500" }, t('SET_APPOINTMENT'))))),
                    React.createElement("div", { className: "space-y-2" },
                        stop.window_start && (React.createElement(IconTextDisplay, { color: "green", icon: React.createElement(CalendarIcon, { className: "w-4 h-4" }) },
                            React.createElement("dl", { className: "text-left" },
                                React.createElement("dt", { className: "mb-1 form-label" }, t('START')),
                                React.createElement("dd", { className: "block text-sm text-gray-900" }, formatDateTime(stop.window_start, timezone, true))))),
                        stop.window_end && (React.createElement(IconTextDisplay, { color: "red", icon: React.createElement(CalendarIcon, { className: "w-4 h-4" }) },
                            React.createElement("dl", { className: "text-left" },
                                React.createElement("dt", { className: "mb-1 form-label" }, t('END')),
                                React.createElement("dd", { className: "block text-sm text-gray-900" }, formatDateTime(stop.window_end, timezone, true))))))),
                dateNotSetForNonDrayage && (React.createElement("div", { className: "mt-2" }, t('NOT_SET'))),
                appointmentStatusVisible && (React.createElement("div", { className: "mt-2 ml-10" },
                    React.createElement(AppointmentConfirmationBadge, { confirmed: !appointment_unconfirmed }))))));
    }
}
StopAppointmentWindow.propTypes = {
    stop: PropTypes.shape({
        window_start: PropTypes.string,
        window_end: PropTypes.string,
        appointment_unconfirmed: PropTypes.bool,
        empty: PropTypes.bool,
        location: PropTypes.array,
    }).isRequired,
    shipment_type: PropTypes.oneOf(['shorthaul', 'drayage', 'rail']),
    editable: PropTypes.bool.isRequired,
    onEditAppointmentWindow: PropTypes.func.isRequired,
};
StopAppointmentWindow.defaultTypes = {
    shipment: 'shorthaul',
};
export default withTranslation()(withLocaleContext(StopAppointmentWindow));
